import React from 'react';
import AllFeaturedCards from '../features/cards/components/AllFeaturedCards';

const AllFeaturedCardsPage = () => {
  return <AllFeaturedCards />;
};

export default AllFeaturedCardsPage;
